import React from 'react'
import PropTypes from 'prop-types'

//TODO: name this differently to avoid confusion with other tutor avatar components
import { Box, Image } from '@chatterbug/aaron'

import Favorite from 'src/ui/Favorite/Favorite'

import fallbackAvatarUrl from './assets/fallbackAvatarUrl.svg'

const TutorAvatar = ({ altText, isFavorite, avatarUrl, name }) => {
  return (
    <Box sx={{ position: 'relative' }}>
      <Image
        width="24px"
        height="24px"
        src={avatarUrl || fallbackAvatarUrl}
        backgroundColor="gray88"
        borderRadius="full"
        alt={name ? name : ''}
        display="block"
      />
      {isFavorite && (
        <Box
          as="span"
          width="11px"
          sx={{
            top: '-9px',
            right: '-5px',
            position: 'absolute',
          }}
        >
          <Favorite border="white" altText={altText} />
        </Box>
      )}
    </Box>
  )
}

TutorAvatar.propTypes = {
  isFavorite: PropTypes.bool,
  avatarUrl: PropTypes.string.isRequired,
  name: PropTypes.string,
  altText: PropTypes.string,
}

export default TutorAvatar
